var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPensil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-pensil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.44943 2.0542H1.97053C1.70692 2.0542 1.45409 2.15892 1.26769 2.34533C1.08128 2.53173 0.976563 2.78455 0.976562 3.04817V10.006C0.976563 10.2696 1.08128 10.5224 1.26769 10.7088C1.45409 10.8952 1.70692 10.9999 1.97053 10.9999H8.92832C9.19194 10.9999 9.44476 10.8952 9.63116 10.7088C9.81757 10.5224 9.92229 10.2696 9.92229 10.006V6.52706",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.17635 1.30879C9.37406 1.11107 9.64222 1 9.92183 1C10.2014 1 10.4696 1.11107 10.6673 1.30879C10.865 1.5065 10.9761 1.77466 10.9761 2.05426C10.9761 2.33387 10.865 2.60203 10.6673 2.79974L5.94595 7.5211L3.95801 8.01808L4.45499 6.03014L9.17635 1.30879Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPensil);
export default __webpack_public_path__ + "static/media/edit-pensil.53a0daaf8703ee33d22b99a79ba45a7e.svg";
export { ForwardRef as ReactComponent };